export { default } from './PageGuides.vue'
